import React, { useState, useRef } from 'react';
import './dnd.css';

// import Property from './Property';
// import SimpleTree from './SimpleTree';
// import data from './Data';

import BizNode from './BizNode';
import IfNode from './IfNode';
import LoopNode from './LoopNode';
import MouseNode from './MouseNode';
import WaitNode from './WaitNode';
import BotNode from './BotNode';
import CallNode from './CallNode';
import RESTNode from './RESTNode';
import KeyNode from './KeyNode';
import RegularNode from './RegularNode';

import BrowserNode from './BrowserNode';
import nodeStyles from './nodeStyles';
import message from './message';
import customConnectionLine from './customConnectionLine';
import getFields from './ActionFields';

import ButtonEdge from './ButtonEdge';



import { save } from 'save-file';



import ReactFlow, {
    ReactFlowProvider,
    addEdge,
    removeElements,
    Controls, Background
  } from 'react-flow-renderer';  

  const nodeStyle = {
    background: 'beige',
    color: 'purple',
    border: '1px solid #222138',
    width: 50,
  };
  
  let id = 0;

  const style = {
    background: '#ccccff',
    width: '100%',
    height: 730,
  };

  const IFNodeStyle = {
    background: 'gray',
    color: 'purple',
    border: '1px solid #222138',
    textAlign: 'center',
    width: 600,
  };
  const edgeStyle = {
    color: 'darkblue',

  };



    var lastPosition = {x:250, y:100}        

    const Flow = (props) => {
  
    const initialElements = [];

    const getId = () => `dndnode_${id++}`;

    const [model, setModel] = useState(null)
    
    const [selectedElement, setSelectedElement] = useState(null)
  
    const [fromElement, setFromElement] = useState(1)
    const [toElement, setToElement] = useState(2)
  
  
    const reactFlowWrapper = useRef(null);
    const [reactFlowInstance, setReactFlowInstance] = useState(null);
    const [elements, setElements] = useState(initialElements);
    const onConnect = (params) => setElements((els) => addEdge(params, els));
    const onElementsRemove = (elementsToRemove) =>
      setElements((els) => removeElements(elementsToRemove, els));

      




      const getNodeType = (name) => {

        if (name == "Task") {return "BizNode"}
        if (name == "Call") {return "CallNode"}
        if (name == "Bot") {return "BotNode"}
        if (name == "REST") {return "RESTNode"}
        if (name == "Mouse") {return "MouseNode"}
        if (name == "If") {return "IfNode"}
        if (name == "Key") {return "KeyNode"}
        if (name == "KeyInsert") {return "KeyNode"}
        if (name == "LoopImageMatch") {return "LoopNode"}
        if (name == "Wait") {return "WaitNode"}
        if (name.startsWith("Browser")) {return "BrowserNode"}
        return 'RegularNode'

    } 


    const nodeTypes = {
      BizNode: BizNode,
      IfNode:IfNode,
      LoopNode: LoopNode,
      MouseNode:MouseNode,
      KeyNode:KeyNode,
      BotNode:BotNode,
      CallNode:CallNode,
      RESTNode:RESTNode,
      WaitNode:WaitNode,
      BrowserNode:BrowserNode,
      RegularNode:RegularNode
    };

      
      

      const renderModel = () => {
        var content = props.data;
        if (content  == '' || content == null)
        return false

        console.log("File contains : " + content)
  
        onElementsRemove(elements)

        const fileModel = JSON.parse(content)
        fileModel.map(fileItem =>{
          const eventItems = fileItem.content  
          const events = JSON.parse(eventItems)
          // setRealModel(events)
          const ind = fileItem.name.indexOf('.')
          // setEntityName(fileItem.name.substring(0,ind).toUpperCase())
  
          var sourceElement = fromElement
          events.map(item => {
  
          var id = getId()
          //const type = 'default'
          var position = {x:lastPosition.x , y: lastPosition.y + 150}
          var name = item["py/object"]
          var ind = name.lastIndexOf('Event')
          name = name.substring(7, ind)
          const type = getNodeType(name)
          
          const newNode = {
            id: id,
            type,
            position,
            style:nodeStyle, 
            data: { label: name, attributes:item }
          };
    
          const edgeId = sourceElement + '-' + id
          const newEdge = 
          {
            id: edgeId,
            source: sourceElement,
            style:{edgeStyle},
            target: id,
            type:'step',
            arrowHeadType: 'arrow',
          }
           
          setFromElement(newNode.id)
          setElements((es) => es.concat(newNode));
          setElements((es) => es.concat(newEdge));
  
          sourceElement = newNode.id
          lastPosition = position
    
        });
  
        setFromElement(sourceElement)

        const lastEdgeId = getId()
        const lastEdge = 
        {
          id: lastEdgeId,
          source: sourceElement,
          target: toElement,
          type:'step',
          // animated: true,
          // type:'buttonedge',
          arrowHeadType: 'arrow',
        }
        setElements((es) => es.concat(lastEdge));
  
        });
        return true;
  
      }


    const onLoad = (_reactFlowInstance) =>
    setReactFlowInstance(_reactFlowInstance);
  
    // const onDragOver = (event) => {
    //   event.preventDefault();
    //   event.dataTransfer.dropEffect = 'move';
    // };
  


    // const onDrop = (event) => {
    //   event.preventDefault();
  
    //   const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
    //   const type = event.dataTransfer.getData('application/reactflow');
    //   const name = event.dataTransfer.getData('name');
    //   const position = reactFlowInstance.project({
    //     x: event.clientX - reactFlowBounds.left,
    //     y: event.clientY - reactFlowBounds.top,
    //   });
    //   const id = getId() 
    //   const newNode = {
    //     id: id,
    //     type,
    //     position,
    //     style:nodeStyle, 
    //     data: { label: name },
    //   };
    //   const edgeId1 = fromElement + '-' + id
    //   const edgeId2 = id + '-' + toElement
    //   const newEdge1 = 
    //   {
    //     id: edgeId1,
    //     source: fromElement,
    //     target: id,
    //     animated: true,
    //     arrowHeadType: 'arrow',
    //   }
       
    //   const newEdge2 = 
    //   {
    //     id: edgeId2,
    //     source: id,
    //     target: toElement,
    //     animated: true,
    //     arrowHeadType: 'arrow',
    //   }
    //   setFromElement(newNode.id)
    //   setElements((es) => es.concat(newNode));
    //   setElements((es) => es.concat(newEdge1));
    //   setElements((es) => es.concat(newEdge2));
    // };
  
    const onElementClick = (event, element) => {
        event.preventDefault();
        setSelectedElement(element)
    }


 renderModel()

 return (

  <div className="designer">

  <ReactFlowProvider>

      {/* <SimpleTree title="Additional Activities" data = {data}/>  */}

      <div className="reactflow-wrapper" ref={reactFlowWrapper}> 

        <ReactFlow
        style={style}
        elements={elements}
        onConnect={onConnect}
        onElementsRemove={onElementsRemove}
        onLoad={onLoad}
        nodeTypes={nodeTypes}

        // onDrop={onDrop}
        // onDragOver={onDragOver}
        onElementClick={onElementClick}
    >
        <Controls />
        <Background variant="dots" color="blue" gap={10} /> 

        </ReactFlow>
      </div>
      
      {/* <Property element={selectedElement}>
      
  </Property> */}

  </ReactFlowProvider>

  </div>



);

};

export default Flow;